'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReduxDomFactory = undefined;

var _ReduxDomFactory = require('./ReduxDomFactory');

var _ReduxDomFactory2 = _interopRequireDefault(_ReduxDomFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ReduxDomFactory = _ReduxDomFactory2.default;
exports.default = _ReduxDomFactory2.default;